import * as React from 'react';
export const playFilledSvg = React.forwardRef(function playFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1 .874A.75.75 0 0 1 2.156.243l4.863 3.126a.75.75 0 0 1 0 1.262L2.156 7.757A.75.75 0 0 1 1 7.127V.873Z',
    }),
  );
});
playFilledSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var playFilled = {
  category: 'icon',
  colorable: true,
  name: 'playFilled',
  svg: playFilledSvg,
};
